import {styles} from './CoachesTeamSummaryCardItem.style';
import {
  GetStylesParams,
  ShouldShowParams,
} from './CoachesTeamSummaryCardItem.types';

export const shouldShow = ({
  isBusinessLeaderMetric = false,
  isBusinessLeader = false,
}: ShouldShowParams) =>
  (isBusinessLeaderMetric && isBusinessLeader) || !isBusinessLeaderMetric;

export const getStyles = ({isFirstItem}: GetStylesParams) =>
  isFirstItem ? {...styles.listItem, ...styles.listItemFirst} : styles.listItem;
